import { render, staticRenderFns } from "./AssetSearch.vue?vue&type=template&id=54666438&scoped=true&"
import script from "./AssetSearch.vue?vue&type=script&lang=js&"
export * from "./AssetSearch.vue?vue&type=script&lang=js&"
import style0 from "./AssetSearch.vue?vue&type=style&index=0&id=54666438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54666438",
  null
  
)

export default component.exports